import { HoldingsResponse } from "../types/portfolio-types.types";
import { API_PATHS } from "../constants/api-paths";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { encryptedRequest } from "../core/api.client";

export const getHoldings = async (authCode?: string, page?: number, limit?: number) => {
  try {
    const { mobileNo } = await getSessionData();
    if (!mobileNo) {
      throw new Error("Missing Mobile No");
    }
    const response = await encryptedRequest<HoldingsResponse>({
      method: "POST",
      url: API_PATHS.getHoldings,
      data: {
        mobileNo,
        authCode,
        page: page || 1,
        limit: limit || 10,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching holdings:", error);
    throw error;
  }
};
